import * as React from "react";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Paths from "@tunnel-enums/index";
import * as Lodash from "lodash";
import CitilogIncidents from "@tunnel-components/@sharded/widgets/box/tools/incident/component";
import Sorting from "@tunnel-components/@sharded/sorting/component";
import * as cx from "classnames";
import VirtualLoader from "@tunnel-components/@sharded/@widgets/virtual-loader/component";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import VirtualPagination from "@tunnel-components/@sharded/@widgets/virtualized/pagination";
import * as Utils from "@Cyclope-Utils/index";
import * as i18next from "i18next"; // traduction
import * as Enums from "@tunnel-enums/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    totalElements,
    itemsPerPage,
    onUpdateCurrentPageNumber,
    currentPageNumbers,
    onSortingBy,
    onOpen,
    loading,
    errorserver,
    citilogData,
    errorvideo,
    onClose,
    filterHeader,
    filter,
    onOpenhoverCard,
    openHoverCard,
    onClosehoverCard,
    extractIncidentSequence,
  } = props;

  /**
   * @description : retourne un tableau de type string ( )
   * @const
   * @name csvData
   * @type { any []  }
   */
  const csvData: any[] =
    citilogData &&
    Utils.cloneObjectOrArray(citilogData)
      .filter((elem: any) => elem)
      .map((element: any) => {
        element.camera = element.camera.code;
        element.qualificationTime = element.qualified
          ? element.qualificationTime
          : null;
        return element;
      });
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.CITILOGLISTS,
  ]);

  /**
   * a callback method to define yourself depending on what you want
   * to do with your data. This method is the core of your list,
   * it is here that you define what will be rendered thanks to your data
   */
  const rowRenderer = ({ index, key, style }: any) => {
    return (
      <div
        key={key}
        style={{
          ...style,
          width: "100%",
          marginBottom: "15px",
        }}
      >
        {!Lodash.isUndefined(citilogData[index]) &&
          !Lodash.isEmpty(citilogData[index]) &&
          !!citilogData[index] && (
            <CitilogIncidents
              classnames={cx("actions-qualified extract-icon", {})}
              Elem={citilogData[index]}
              extractIncidentSequence={
                citilogData[index].camera &&
                extractIncidentSequence(
                  citilogData[index].camera.id,
                  citilogData[index].startTime,
                  citilogData[index].duration
                )
              }
            />
          )}
      </div>
    );
  };
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      snackbarError={errorvideo}
      someTextError={i18next.t("impossible d'extraire la video")}
      loading={loading}
      error={errorserver}
    >
      <section className="tunnel-site animated fadeIn">
        {!Lodash.isEmpty(citilogData) && !!citilogData && (
          <BreadCrumb
            csvData={csvData}
            iconIncident={true}
            links1={Paths.PathsNamesEnums.CITILOGINCIDENT}
            title={i18next.t("incidents")}
            breadText1={i18next.t("Citilog")}
            filtreHistoryCitilog={authorization && totalElements !== 0}
            onOpenhoverCard={onOpenhoverCard}
            openHoverCard={openHoverCard}
            onClosehoverCard={onClosehoverCard}
          />
        )}
        <div className="contentAllSiteWithoutOnglet">
          <section className="columnsWithoutOngletForArray">
            <section className="arrays">
              {!Lodash.isEmpty(citilogData) &&
                !!citilogData &&
                totalElements !== 0 && (
                  <section className="arraysHeader">
                    <span
                      className="arraysHeaderSpanAuto"
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos">
                          <p style={{ cursor: "default" }}>
                            {" "}
                            {i18next.t("identifiant")}{" "}
                          </p>
                        </div>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "26%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(0)}>
                          <p>{i18next.t("date")}</p>
                          <Styled.Icon
                            isrotate={filterHeader[0]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.Icon>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[0]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            dateBoolean={true}
                            onSortingAZ={onSortingBy(
                              "orderBy=raisedAt&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=raisedAt&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "26%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(1)}>
                          <p>{i18next.t("camera")}</p>
                          <Styled.Icon
                            isrotate={filterHeader[1]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.Icon>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[1]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            onSortingAZ={onSortingBy(
                              "orderBy=camera&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=camera&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      onMouseLeave={onClose}
                      style={{ width: "26%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos" onClick={onOpen(2)}>
                          <p> {i18next.t("types d'incident")}</p>
                          <Styled.Icon
                            isrotate={filterHeader[2]}
                            style={{ width: "8px", right: "-15px" }}
                          >
                            <StyledIcon arrow={true} />
                          </Styled.Icon>
                        </div>
                      </div>
                      <div className="styleDivSort">
                        <Styled.BreadBoxContainer
                          isVisible={filter[2]}
                          style={{
                            color: "black",
                            width: "120px",
                            top: "0",
                            margin: "0 auto",
                            position: "relative",
                          }}
                        >
                          <Sorting
                            onSortingAZ={onSortingBy(
                              "orderBy=raisedAt&direction=ASC"
                            )}
                            onSortingZA={onSortingBy(
                              "orderBy=raisedAt&direction=DESC"
                            )}
                          />
                        </Styled.BreadBoxContainer>
                      </div>
                    </span>
                    <span
                      className="arraysHeaderSpanAuto"
                      style={{ width: "11%" }}
                    >
                      <div className="arraysHeaderContenair">
                        <div className="arrayHeaderInfos">
                          <p style={{ cursor: "default" }} />
                        </div>
                      </div>
                    </span>
                  </section>
                )}

              {totalElements !== 0 && itemsPerPage && (
                <VirtualPagination
                  classnames="incident-items with-1-columns " // la classe
                  width="100%" //
                  heightView="100%" // hauteur et largeur de la fenètre
                  rowHeight={53} // Hauteur de la cellule
                  arrayContent={!Lodash.isEmpty(citilogData)} // Boolean vérifie si le tableau est vide
                  rowRenderer={rowRenderer} // élement JSX , column
                  itemPerPage={itemsPerPage} // nombre d'élement par page
                  totalItemLength={totalElements} // nombre total d'élement
                  currentPageNumbers={currentPageNumbers} // la page courante
                  onUpdateCurrentPageNumbers={onUpdateCurrentPageNumber} // function de mise à jour de la page courante
                  itemPerRow={1}
                  totalRowElements={citilogData.length}
                  widthView="100%" //
                />
              )}
              {totalElements === 0 && <VirtualLoader />}
            </section>
          </section>
        </div>
      </section>
    </LayoutGrid>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  totalElements?: any;
  itemsPerPage?: any;
  onUpdateCurrentPageNumber?: any;
  currentPageNumbers?: any;
  loading?: boolean;
  errorserver?: boolean;
  citilogData?: any;
  onOpenhoverCard?: any;
  openHoverCard?: boolean;
  onClosehoverCard?: any;
  extractIncidentSequence?: any;
  errorvideo?: boolean;
  onClose?: any;
  filterHeader?: any;
  filter?: any;
  onSortingBy?: any;
  onOpen?: any;
}

/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/tools/citilogIncident/home/component.tsx